import { mergeObjects } from '@utils/objectUtils';
import { Translations } from '../../types';
import translation from './translation.json';
import untrackedTranslation from './untrackedTranslation.json';

export const translationsDE: Translations = {
  translation: mergeObjects(translation, untrackedTranslation),
};
